import { render } from "./CheckSymptoms.vue?vue&type=template&id=e6f6904a&scoped=true&ts=true"
import script from "./CheckSymptoms.vue?vue&type=script&lang=ts"
export * from "./CheckSymptoms.vue?vue&type=script&lang=ts"

import "./CheckSymptoms.vue?vue&type=style&index=0&id=e6f6904a&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6f6904a"]])

export default __exports__